import { Link } from "react-router";
import "../style/Page404.css";
// images
import lostScreenImg from "/images/lost-screen.jpg";

const Page404=()=> {
    return (
        <main className="page404_content">
            <h1 className="page404_title">Page 404</h1>
            <img className="page404_image" src={lostScreenImg} alt="personne cherchant un vinyle" />
            <p className="page404_text">
                Cette page est introuvable, tel un vinyle égaré sur une étagère.<br/>
                Vérifiez l’adresse ou revenez à l’accueil pour reprendre votre exploration musicale.
            </p>
            <Link to="/" className="page404_link"><p>Revenir à l'accueil</p></Link>
        </main >
    )
}
export default Page404;